import { render, staticRenderFns } from "./UnacknowledgedEntries.vue?vue&type=template&id=028e5ae8&scoped=true&"
import script from "./UnacknowledgedEntries.vue?vue&type=script&lang=js&"
export * from "./UnacknowledgedEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e5ae8",
  null
  
)

export default component.exports